import routes from 'js/core_pre_webpack/routes';

export const CHECKOUT_TRIGGER = 'loswp-tabs-hero';

// Attribution tag on the checkout URL. Defaulted so every existing caller keeps the tabs-hero
// trigger it has today; a new surface passes its own so its checkout visits are separable.
// NOTE a trigger is not purely cosmetic: Api::V0::RegistrationsController special-cases known
// pack triggers to stash the pending doc id, which is what lets
// SingleWorkController#recover_loswp_tabs_hero_pack_download return a visitor who abandons
// checkout to their free download. A trigger not on that list loses the recovery.
// The trigger goes on the checkout params AND inside upgradeRedirect, because the two are read by
// different things. Checkout reads the param; the page the visitor RETURNS to after paying only
// ever sees upgradeRedirect, and two hooks parse the trigger back out of it:
// CheckoutController#loswp_preview_gate_destination, which decides whether to skip the upgrade
// survey, and BulkDownloadCountsController, which grants the post-upgrade grace that stops a
// paying visitor being shown an upsell. Omitting it from the URL loses both, silently.
//
// Only added when a caller passes a trigger explicitly, so the default tabs-hero redirect is
// byte-identical to what it is today.
export const packCheckoutOpts = (workId: number, trigger?: string) => ({
  feature: 'BULK_DOWNLOAD',
  trigger: trigger ?? CHECKOUT_TRIGGER,
  upgradeRedirect: encodeURIComponent(
    routes.show_work_url(
      trigger
        ? { id: workId, bulkDownload: true, trigger }
        : { id: workId, bulkDownload: true },
    ),
  ),
});
